import React, { useEffect, useState } from 'react';
import "./index.css";
// import Navbar from "../Navbar"
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ColorRing } from 'react-loader-spinner';
import { IoChevronBackOutline } from "react-icons/io5";

const Index = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data,setData] = useState("");
  const [loader,setLoader] = useState(false);

  useEffect(()=>{
    const state = location.state;
    if(state !== null)
    {
      setLoader(true);
      const apiHit =async()=>{
        try {
          const response = await axios.get("https://app.minemi.ai/api/webData");
          localStorage.setItem("termData",response.data.data[state.name]);
          setData(response.data.data[state.name]);
          setLoader(false);
        } catch (err) {
          setLoader(false);
        }
      }

      apiHit();
    }else{
      const termData = localStorage.getItem("termData");
      if(termData === null)
      {
        navigate("/",{replace: true,state:{msg:"Unauthorized Access!"}});
      }else
      {
        setData(termData);
      }
    }
  },[]);

  return (
    <>
        {/* <Navbar/> */}
        {!loader ?<div id="experianTermCon">
            <Link to="/" style={{textDecoration:"none"}}> 
                <button id="back-btn">
                  <IoChevronBackOutline id='back-icon' />
                  <span>Back</span>
                </button>
            </Link>
            
            <div dangerouslySetInnerHTML={{ __html: data }} />
        </div>:
        <div id="loaderCon">
          <ColorRing
            visible={loader}
            height="60"
            width="60"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#59266D','#59266D','#59266D', '#59266D', '#59266D','#59266D']}
          />
        </div>
        }
    </>
  )
}

export default Index;
